import { cleanEnv, str, url } from 'envalid';

const envC = cleanEnv(process.env, {
    REACT_APP_BASE_NAME: str(),
    REACT_APP_API_URL: url(),
});

export default envC;

export const env = {
    REACT_APP_BASE_NAME: envC.REACT_APP_BASE_NAME,
    REACT_APP_API_URL: envC.REACT_APP_API_URL,
};